import { ToolLink } from "@/lib/types/app";
import { ToolCard } from "@/components/ToolCard";

interface ToolGridProps {
  tools: ToolLink[];
  bookmarks: string[];
  toggleBookmark: (id: string) => void;
  userIsPilot: boolean;
}

export default function ToolGrid({
  tools,
  bookmarks,
  toggleBookmark,
  userIsPilot,
}: ToolGridProps) {
  return (
    <div
      className="grid gap-6"
      style={{
        gridTemplateColumns: "repeat(auto-fill, minmax(auto, 350px))",
      }}
    >
      {tools.map(
        (tool) =>
          tool?.id && (
            <ToolCard
              key={tool.id}
              tool={tool}
              bookmarks={bookmarks}
              toggleBookmark={toggleBookmark}
              userIsPilot={userIsPilot}
            />
          )
      )}
    </div>
  );
}
